import { toast } from 'react-toastify';
import { ToastV2Options } from './toastV2.type';

const defaultOptions = {
  position: 'bottom-right' as const,
  hideProgressBar: true,
  autoClose: 2000,
  closeButton: false,
};

export const toastV2 = {
  success: (message: string, options?: ToastV2Options) => {
    toast.success(message, { ...defaultOptions, ...options });
  },

  error: (message: string, options?: ToastV2Options) => {
    toast.error(message, { ...defaultOptions, ...options });
  },

  info: (message: string, options?: ToastV2Options) => {
    toast.info(message, { ...defaultOptions, ...options });
  },

  warning: (message: string, options?: ToastV2Options) => {
    toast.warning(message, { ...defaultOptions, ...options });
  },
};
